import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";
import { LoaderIcon } from "../Icons";

const DocumentUpload = ({ refetch, setShow, partner }) => {
  const { backendUrl } = useAuth();
  const [documents, setDocuments] = useState([{ name: "", file: null }]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef();

  const handleChange = (index, field, value) => {
    const updated = [...documents];
    updated[index][field] = value;
    setDocuments(updated);
  };

  const addField = () => {
    setDocuments([...documents, { name: "", file: null }]);
  };

  const removeLastField = () => {
    if (documents.length > 1) {
      setDocuments(documents.slice(0, -1));
    }
  };

  const handleSubmit = async (e) => {
    try {
      setIsLoading(true);
      e.preventDefault();

      const formData = new FormData();

      documents.forEach((doc, index) => {
        if (doc.file) {
          formData.append(`name`, doc.name);
          formData.append(`documents`, doc.file);
        }
      });
      let response = await fetch(
        `${backendUrl}/api/partnership/partner/upload-documents/${partner.id}`,
        {
          method: "POST",
          body: formData,
        }
      );
      if (!response.ok) {
        let result = await response.json();
        console.log(result);
        throw new Error(result.message);
      }
      let result = await response.json();
      toast.success(result.message);
      setShow(false);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      await refetch();
      setIsLoading(false);
    }
  };

  return (
    <Modal
      onHide={() => setShow(false)}
      show={true}
      dialogClassName="new-entity-modal"
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={true}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1> Upload document for company {partner.company_name}</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container my-4">
          <h4>Upload Documents</h4>
          {isLoading && (
            <div className="global-spinner">
              <LoaderIcon className="spin text-primary" />
            </div>
          )}
          <form ref={formRef} onSubmit={handleSubmit}>
            {documents.map((doc, index) => (
              <div className="row mb-3" key={index}>
                <div className="col-md-5 mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Document Name"
                    value={doc.name}
                    onChange={(e) =>
                      handleChange(index, "name", e.target.value)
                    }
                    required
                  />
                </div>
                <div className="col-md-5 mb-2">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      handleChange(index, "file", e.target.files[0])
                    }
                    required
                  />
                </div>
                {index === documents.length - 1 && documents.length > 1 && (
                  <div className="col-md-2 mb-2 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={removeLastField}
                    >
                      &times;
                    </button>
                  </div>
                )}
              </div>
            ))}

            <div className="mb-3">
              <button
                type="button"
                className="btn btn-outline-primary me-2"
                onClick={addField}
              >
                + Add Another Document
              </button>
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => formRef.current?.requestSubmit()}
          disabled={isLoading}
          className="btn btn-primary"
        >
          {isLoading ? "Uploading Documents..." : "Upload Documents"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentUpload;
